import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getImpactPageData } from './api';
import type { ImpactPageDataLoadErrorCode } from './types';

export const {
	Context: ImpactPageDataContext,
	Provider: ImpactPageDataContextProvider,
	useContext: useImpactPageData,
	useAsyncData: useImpactPageDataFromApi,
	prefetchAsyncData: prefetchImpactPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'ImpactPageDataContext',
	dataProperty: 'pageData',
	getData: getImpactPageData,
	hookDeps: ({ countryCode, locale }) => [countryCode, locale],
	getUniqueId: ({ countryCode, locale }) => `${countryCode}:${locale}`,
	errorHandler: pageDataErrorHandler<ImpactPageDataLoadErrorCode>(),
});
